import React from 'react'
import injectSheet from 'react-jss'

import Button from 'components/Button'

const styles = {
	background: {
		backgroundImage: 'url(static/img/background1.jpg)',
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		width: '100%',
		height: '100%',
	},
	backgroundShade: {
		width: '100%',
		height: '100%',
		backgroundColor: 'rgba(0,0,0,.4)',
	},
	button: {
		outline: 'none',
		backgroundColor: 'rgba(0,0,0,0)',
		color: 'white',
		fontSize: '14px',
		textAlign: 'center',
		border: 'none',
		textTransform: 'uppercase',
		fontWeight: 'lighter',
		height: 48,
		minWidth: 64,
		padding: [[6, 8]],
	},
	buttonBox: {
		'&:hover': {
			backgroundColor: 'rgba(0,0,0,.12)',
			borderColor: 'gray',
			color: 'gray',
		},
		minWidth: 64,
		height: 34,
		lineHeight: '34px',
		padding: [[0, 8]],
		border: [[1, 'white', 'solid']],
	},
	heading: {
		fontWeight: 'lighter',
	},
	subheading: {
		fontWeight: 'lighter',
	},
	jumbotron: {
		color: 'white',
		margin: 'auto auto',
		maxWidth: 512,
		padding: 8,
		textAlign: 'center',
	},
	'@media (min-width: 1024px)': {
		jumbotron: {
			margin: 'auto auto',
			maxWidth: 512,
			padding: 0,
		},
	},
	navigation: {
		height: 56,
		position: 'fixed',
		top: 0,
		display: 'flex',
		flexDirection: 'row',
		color: 'white',
		padding: [[0, 24]],
		zIndex: 10,
		width: '100%',
	},
	main: {
		position: 'fixed',
		top: 0,
		width: '100%',
		height: '100%',
		// paddingTop: 64,
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
	},
	title: {
		fontSize: 20,
		fontWeight: 'lighter',
		lineHeight: '56px',
		display: 'inline-flex',
	},
	navigationLinkList: {
		position: 'fixed',
		right: 0,
		margin: [[ 0, 24, 0, 0 ]],
		listStyle: 'none',
		display: 'inline-flex',
		lineHeight: '56px',
	},
	'@media (max-width: 600px)': {
		navigation: {

		},
		navigationLinkList: {
			display: 'none',
		},
		title: {
			textAlign: 'center',
			width: 'calc(100% - 32px)',
		}
	},
}

const Home = ({classes, children}) => (
	<div className={classes.background}>
		<div className={classes.backgroundShade}>
			<div className={classes.navigation}>
				<span className={classes.title}>
					codebanana
				</span>
				<ul className={classes.navigationLinkList}>
					<li><Button>services</Button></li>
					<li><Button>about</Button></li>
					<li><Button>contact</Button></li>
				</ul>
			</div>
			<div className={classes.main}>
				<div className={classes.jumbotron}>
					<h1 className={classes.heading}>
						Make the Right Choices
					</h1>
					<p className={classes.subheading}>
						The technology landscape is a rugged and unforgiving jungle of options.
						Work with codebanana to empower your business with the right technology solutions.
					</p>
					<Button border>learn more</Button>
				</div>
			</div>
		</div>
	</div>
)

export default injectSheet(styles)(Home)



// WEBPACK FOOTER //
// ./src/views/Home/Home.jsx